import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

export class CondensateDrainLinesBus extends BaseBus{
    constructor(busObj: CondensateDrainLinesBus) {
        super(busObj);

    }
    CID(): any {
        return this.bidCondensateSizeId ;
    }
    setId(id: any) {
        this.bidCondensateSizeId  = id;
    }
    initialize(data: CondensateDrainLinesBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
       this.bidSheetDetailId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: CondensateDrainLinesBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    bidCondensateLineId     : string;
    bidSheetDetailId        : string;
    bidCondensateSizeId     : string;  //using this id <-- Change CID() return value if bidCondensateSizeId has more bidPipeTypeId
    bidPipeTypeId           : string;
    pipeLF                  : string;
    insertDt                : Date;
    insertUserId            : string;
    updateDt                : Date;
    updateUserId            : string;
    condensateSizeValue     : string;
    condensateSizeDescr     : string;
    sequence                : number;
    pipeTypeValue           : string;
    pipeTypeDescr           : string;
}